import BaseStyle from '@primevue/core/base/style';

var DeferredContentStyle = BaseStyle.extend({
  name: 'deferredcontent'
});

export { DeferredContentStyle as default };
//# sourceMappingURL=index.mjs.map
